// extracted by mini-css-extract-plugin
export default {"actions":"StudioEmail_actions__7OC+f"};